import React from 'react';
import Styled from './style';
import Form from './Form';
import { scrollbarList } from './config';

const Component = ({ apiStatus, history, clearApiStatus, getToCheckout, addSigneeName, getSigneeInfo, getCompanyInfoApi }) => {
  return (
    <Styled.Wrapper>
      <h1 className="stepTitle">Clutch ELD Terms of Service</h1>
      <div className="tcSection" id="scroll">
        <div className="scrollbar">
          {scrollbarList.map(({ type, text, child, className }) => {
            if (type === 'contentSection') {
              return (
                <p className={`contentSection ${className || ''}`}>
                  {text}
                  {child ? <span className="capitalize">{child}</span> : null}
                </p>
              );
            }
            return <label className="subHeading">{text}</label>;
          })}
        </div>
      </div>
      <div className="loginformwrap">
        <Form
          apiStatus={apiStatus}
          history={history}
          clearApiStatus={clearApiStatus}
          getToCheckout={getToCheckout}
          addSigneeName={addSigneeName}
          getSigneeInfo={getSigneeInfo}
          getCompanyInfoApi={getCompanyInfoApi}
        />
      </div>
    </Styled.Wrapper>
  );
};

export default Component;
